import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useStore, useDispatch } from "../../store";
import { fetchCounterInfo } from "../../store/actions/counter";
import { useEventBus, EVENT_BUS_EVENTS } from "../../util/useEventBus";
import { Anchor } from "discover.medical.react-component-library";
import { StyledCmeButton } from "./_.styled";

const CmeButton = ({
  buttonSize,
  buttonUrl,
  buttonLabel,
  availableCreditsCount,
  isExternalNavigation,
}) => {
  const eventBus = useEventBus();
  const dispatch = useDispatch();

  const {
    counter: { available },
  } = useStore();

  useEffect(() => {
    const handler = () => fetchCounterInfo(dispatch);
    eventBus.on(EVENT_BUS_EVENTS.ITEM_VIEWS_POSTED, handler);
    return () => eventBus.detach(EVENT_BUS_EVENTS.ITEM_VIEWS_POSTED, handler);
  }, [eventBus, dispatch]);

  const counterValue = available || availableCreditsCount;
  const buttonText = (
    <>
      {buttonLabel}{" "}
      {!!counterValue && (
        <span data-testid="ce-cme-button-counter">&nbsp;{counterValue}</span>
      )}
    </>
  );

  return (
    <Anchor
      data-testid="ce-cme-button"
      href={buttonUrl}
      linkComponent={isExternalNavigation ? "a" : Link}
    >
      <StyledCmeButton size={buttonSize}>{buttonText}</StyledCmeButton>
    </Anchor>
  );
};

export default CmeButton;
